<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oqu6wD/tc-custom/9781467451284.jpg?1744434888029" alt="This image is the cover for the book Acts of Interpretation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Acts of Interpretation
      </h1>
      <p class="bookDescription body article font2">
        <p>This book features essays by biblical scholars and theologians offering broad reflections on key interpretive issues, rich readings of challenging biblical texts, and interaction with the Christian exegetical tradition from Melito of Sardis to Dietrich Bonhoeffer.</p><p>The contributors to this volume are leading figures in the theological interpretation of Scripture. Mindful of the Bible’s role in relation to God’s purposes, people, and world, these essays together offer “acts of interpretation” that aim to advance the faithful and fruitful correlation of Scripture, theology, and culture.</p><p><b>Contributors:</b></p>Craig G. Bartholomew<br/> Hans Boersma<br/> S. A. Cummins<br/> Peter Enns<br/> Stephen E. Fowl<br/> Joel B. Green<br/> Edith M. Humphrey<br/> Charles Raith II<br/> Christopher R. Seitz<br/> Robert W. Wall<br/> Jens Zimmermann
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S. A. Cummins, Jens Zimmermann
      </h2>
      
      <p class="authorDescription body article"><BR /><B>S. A. Cummins</B>&#160;is professor of religious studies at TrinityWestern University, Langley, British Columbia.<BR /><BR /><B>Jens Zimmermann</B>&#160;is Canada Research Professor of Interpretation, Religion, and Culture at Trinity Western University and visiting professor of philosophy, literature, and theology at Regent College, Vancouver.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7328fe80